/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'zone': {
    width: 19.9,
    height: 13.9,
    viewBox: '0 0 19.9 13.9',
    data: '<g _fill="none" fill-rule="evenodd" _stroke="#6135ff" stroke-linejoin="round" stroke-width=".9"><path pid="0" d="M19.45 6.95L14.7 3.7 9.95.45l-9.5 6.5 9.5 6.5z"/><path pid="1" d="M14.45 4.45l-9 6m0-6l9 6" opacity=".4"/><path pid="2" d="M19.45 6.95L14.7 3.7 9.95.45l-9.5 6.5 9.5 6.5z"/><path pid="3" d="M14.45 4.45l-9 6m0-6l9 6" opacity=".4"/></g>'
  }
})
